import axios from 'axios';
const moment = require('moment');

async function errorHandler(error) {
    console.log(error);
    if (error.response && error.response.data) {
        throw error.response.data;
    } else {
        throw error;
    }
}

export default {
    async list(obj = {}) {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'terimadari', 'kodeacc', 'namaacc', 'kodebank', 'paymethod', 'trxgroup', 'iogroup', 'poststatus'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/rop${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            return list;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async bankaccount() {
        try {
            const { data } = await axios.get("/bankcashacc/allaccount");
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async bankacconly() {
        try {
            const { data } = await axios.get("/bankcashacc/bankaccount");
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async byrsemu(obj) {
        try {
            const { data } = await axios.get(`apinv/byrsemu/${obj.apinvkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async byrsemuAdv(obj) {
        try {
            const { data } = await axios.get(`advance/byrsemu/${obj.advanKey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async byrsemuAdvSet(obj) {
        try {
            const { data } = await axios.get(`advsettle/byrsemu/${obj.advSttlKey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async byrsemuExp(obj) {
        try {
            const { data } = await axios.get(`expense/byrsemu/${obj.expenKey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async currency() {
        try {
            const { data } = await axios.get("/currency/cbo");
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async paymentdetail(obj) {
        try {
            const { data } = await axios.get(`rop/paymentdetail/${obj.id}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async postingPayment(obj) {
        try {
            await axios.put(`rop/postingpayment/${obj.trbankkey}`);
        } catch (error) {
            await errorHandler(error);
        }
    },
    async postingUndo(obj) {
        try {
            await axios.put(`rop/postingundo/${obj.trbankkey}`);
        } catch (error) {
            await errorHandler(error);
        }
    },
    async postingBulkBank(obj) {
        try {
            await axios.post(`rop/posting-bulk-bank`, obj);
        } catch (error) {
            await errorHandler(error);
        }
    },
    async unpostingBulkBank(obj) {
        try {
            await axios.post(`rop/unposting-bulk-bank`, obj);
        } catch (error) {
            await errorHandler(error);
        }
    },
    async print(obj = {}) {
        try {
            const str = '?key=' + encodeURIComponent(obj.trbankkey);
            const url = `/rop/printpayment${str}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            return link;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async insert(obj) {
        try {
            const { data } = await axios.post("rop", obj);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async remove(obj) {
        try {
            const { data } = await axios.delete(`rop/${obj.trbankkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async exportxls(obj = {}) {
        let url_blob;
        try {
            const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'terimadari', 'kodeacc', 'namaacc', 'kodebank', 'paymethod', 'trxgroup', 'iogroup', 'poststatus'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const response = await axios({
                url: `/rop/exportxls${str}`,
                method: 'GET',
                responseType: 'blob',
            });
            url_blob = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_blob;
            link.setAttribute('download', `request_of_payment_list_${moment().format('YYYYMMDDHHmm')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url_blob), 100);
            return true;
        } catch (error) {
            if (url_blob) window.URL.revokeObjectURL(url_blob);
            await errorHandler(error);
        }
    },
    async actionhistory(obj) {
        try {
            const { data } = await axios.get(`/rop/actionhistory/${obj.trbankkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async approval(formData) {
        try {
            const { data } = await axios.post("rop/send2wf", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async approvalUndo(obj) {
        try {
            const resp = await axios.put(`/rop/send2wfCancel/${obj.trbankkey}`);
            return resp;
        } catch (error) {
            await errorHandler(error);
        }
    }
};
